import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/functions'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

const firebaseConfig = {
  apiKey: "AIzaSyAxY_bACxeYRl69rjDmO4zbDycwaOHd9AI",
  authDomain: "ds2-p4cloud.firebaseapp.com",
  projectId: "ds2-p4cloud",
  storageBucket: "ds2-p4cloud.firebasestorage.app",
  messagingSenderId: "818168800077",
  appId: "1:818168800077:web:1471f214b46daf00ad4d04",
  measurementId: "G-QCHB79M752"
};

firebase.initializeApp(firebaseConfig)

export default firebase
